// extracted by mini-css-extract-plugin
module.exports = {"Input":"ArchiveListFilters_Input__2wd4V","RestorableSwitcher":"ArchiveListFilters_RestorableSwitcher__212_f"};